export default function updateSiteReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'UPDATE_SITE_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'UPDATE_SITE_ERROR':
            return {...state, ...{error: action.error}};

        case 'UPDATE_SITE_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}